import { css } from 'aphrodite/no-important';
import { RedButton, VideoPlayer } from 'components';
import { GenericObject, VideoData } from 'models';
import React from 'react';
import { style } from './style';

interface KeynoteVideoProps {
  videoData: VideoData;
  showBioButton?: boolean;
  onBioClick: (url: string[]) => {};
  copy: GenericObject;
  voiceOverBadgeText?: string;
}

export const KeynoteVideo = ({
  videoData,
  showBioButton = true,
  onBioClick,
  copy,
  voiceOverBadgeText,
}: KeynoteVideoProps) => {
  const styles = style(!!voiceOverBadgeText);

  const renderVideoOrThumbnail = () => {
    if (videoData.video_url) {
      return (
        <VideoPlayer
          src={videoData['video_url']}
          options={{
            aspectRatio: 16 / 9,
            title: videoData['video_title'],
          }}
          data={videoData}
        />
      );
    }

    return <img src={videoData.large_thumbnail_url} alt='' />;
  };

  const videoHeadline = () => {
    const videoHeadline = [videoData.video_title];

    return (
      <>
        {videoHeadline.map((copy, i) => (
          <span key={i} dangerouslySetInnerHTML={{ __html: copy }} />
        ))}
      </>
    );
  };

  return (
    <section className={css(styles.keynoteVideo)}>
      <div className={css(styles.streamingVideoContainer)}>{renderVideoOrThumbnail()}</div>
      <div className={css(styles.videoInfo)}>
        <div className={css(styles.headlineContainer)}>
          <div className={css(styles.headlineInfo)}>
            <h2 className={css(styles.videoTitle, styles.headlineTitle)}>{videoHeadline()}</h2>
            {showBioButton && (
              <RedButton className={css(styles.bioButtonTablet)} onClick={() => onBioClick(videoData.speaker_bio_urls)}>
                {videoData.speaker_bio_urls.length > 1 ? copy.speaker_bios_button_text : copy.speaker_bio_button_text}
              </RedButton>
            )}
          </div>
          {voiceOverBadgeText && <span className={css(styles.voiceOverBadge)}>{voiceOverBadgeText}</span>}
        </div>

        <hr className={css(styles.hr)} />

        <div className={css(styles.subheadlineRowContainer)}>
          <div className={css(styles.subheadlineContainer)}>
            {videoData.keynote_subheadlines.map((headline, i) => (
              <h3
                key={i}
                dangerouslySetInnerHTML={{ __html: headline }}
                className={css(styles.videoTitle, styles.additionalSpeakers)}
              />
            ))}
          </div>
        </div>
      </div>
      {showBioButton && (
        <RedButton
          className={css(styles.bioButtonDesktopAndMobile)}
          onClick={() => onBioClick(videoData.speaker_bio_urls)}>
          {videoData.speaker_bio_urls.length > 1 ? copy.speaker_bios_button_text : copy.speaker_bio_button_text}
        </RedButton>
      )}
    </section>
  );
};
